import { createApp } from 'vue';
import App from './App.vue';

// Lazy-init
export default function dealerLocator(el) {
	const props = JSON.parse(el.dataset.props || '{}');

	let mounted = false;

	const mount = () => {
		if (mounted) return;
		mounted = true;
		createApp(App, props).mount(el);
	};

	if (!('IntersectionObserver' in window)) {
		mount();
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			if (entries.some((entry) => entry.isIntersecting)) {
				mount();
				observer.disconnect();
			}
		},
		{ rootMargin: '200px 0px' }
	);

	observer.observe(el);
}
